var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI and Keyboard Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6C5.77614 6 6 6.22386 6 6.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V6.5C5 6.22386 5.22386 6 5.5 6Z",
    fill: "#D00026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6C8.27614 6 8.5 6.22386 8.5 6.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V6.5C7.5 6.22386 7.72386 6 8 6Z",
    fill: "#D00026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5C11 6.22386 10.7761 6 10.5 6C10.2239 6 10 6.22386 10 6.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V6.5Z",
    fill: "#D00026"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 3.5C14.5 4.05228 14.0523 4.5 13.5 4.5H13V13.5C13 14.6046 12.1046 15.5 11 15.5H5C3.89543 15.5 3 14.6046 3 13.5V4.5H2.5C1.94772 4.5 1.5 4.05228 1.5 3.5V2.5C1.5 1.94772 1.94772 1.5 2.5 1.5H6C6 0.947715 6.44772 0.5 7 0.5H9C9.55229 0.5 10 0.947715 10 1.5H13.5C14.0523 1.5 14.5 1.94772 14.5 2.5V3.5ZM4.11803 4.5L4 4.55902V13.5C4 14.0523 4.44772 14.5 5 14.5H11C11.5523 14.5 12 14.0523 12 13.5V4.55902L11.882 4.5H4.11803ZM2.5 3.5V2.5H13.5V3.5H2.5Z",
    fill: "#D00026"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.73466ea5e000cbdb9202198d18c61f13.svg";
export { ForwardRef as ReactComponent };